import { IBlog } from '../interfaces/IBlog';

export class Blog implements IBlog {
    blogId: number = null;
    name: string = null;
    description: string = null;
    htmlContent: string = null;
    publishDate;
    link: Array<any> = null;

    constructor(data) {
        this.blogId = data.id || data.blogId || null;
        this.name = data.name;
        this.description = data.description;
        this.htmlContent = data.htmlContent || '';
        this.publishDate = new Date (data.publishDate);

    }
}
